import ringTestimonialsFa from "./ringTestimonials-fa.json";
import ringTestimonialsEn from "./ringTestimonials-en.json";
import ringTestimonialsAr from "./ringTestimonials-ar.json";
import ringTestimonialsTr from "./ringTestimonials-tr.json";

import bandTestimonialsFa from "./bandTestimonials-fa.json";
import bandTestimonialsEn from "./bandTestimonials-en.json";
import bandTestimonialsAr from "./bandTestimonials-ar.json";
import bandTestimonialsTr from "./bandTestimonials-tr.json";

import watchTestimonialsFa from "./watchTestimonials-fa.json";
import watchTestimonialsEn from "./watchTestimonials-en.json";
import watchTestimonialsAr from "./watchTestimonials-ar.json";
import watchTestimonialsTr from "./watchTestimonials-tr.json";

import trackerTestimonialsFa from "./trackerTestimonials-fa.json";
import trackerTestimonialsEn from "./trackerTestimonials-en.json";
import trackerTestimonialsAr from "./trackerTestimonials-ar.json";
import trackerTestimonialsTr from "./trackerTestimonials-tr.json";

export const testimonialsLocales = {
    fa: {
        ringTestimonials: ringTestimonialsFa,
        bandTestimonials: bandTestimonialsFa,
        watchTestimonials: watchTestimonialsFa,
        trackerTestimonials: trackerTestimonialsFa,
    },
    en: {
        ringTestimonials: ringTestimonialsEn,
        bandTestimonials: bandTestimonialsEn,
        watchTestimonials: watchTestimonialsEn,
        trackerTestimonials: trackerTestimonialsEn,
    },
    ar: {
        ringTestimonials: ringTestimonialsAr,
        bandTestimonials: bandTestimonialsAr,
        watchTestimonials: watchTestimonialsAr,
        trackerTestimonials: trackerTestimonialsAr,
    },
    tr: {
        ringTestimonials: ringTestimonialsTr,
        bandTestimonials: bandTestimonialsTr,
        watchTestimonials: watchTestimonialsTr,
        trackerTestimonials: trackerTestimonialsTr,
    },
};